import { useLocation } from 'react-router-dom';
import { detectOS, OS, useMediaQuery } from '@ovpn-ui/utils';
import SidebarPanel from './SidebarPanel';
import SidebarLinks from './SidebarLinks';
import { PanelContent, Copyright, LogoContainer } from './Sidebar.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const year = new Date().getFullYear();
const isMobileDevice = os => os === OS.Android || os === OS.Ios;
function Sidebar(props) {
  const {
    links,
    open,
    onToggle,
    onItemClick,
    mobile,
    copyright = false,
    children,
    logo,
    logoCollapsed,
    FooterComponent,
    TenantSwitcher,
    disableScrollFooter = false,
    customWrapper
  } = props;
  const {
    pathname
  } = useLocation();
  const os = detectOS();
  const smallHeight = useMediaQuery(`(max-height:600px)`);
  const scrollFooter = !disableScrollFooter && (mobile && smallHeight || isMobileDevice(os));
  const hasTenants = !!TenantSwitcher;

  /**
   * Latest iOS devices have strange click behaviour.
   * If element with onClick listener has :hover styles
   * then the first tap on that element will trigger only hover event; second tap will trigger click event.
   * This breaks our sidebar.
   *
   * Read more here: https://css-tricks.com/annoying-mobile-double-tap-link-issue/
   */
  const enableIosTap = os === OS.Ios;
  return /*#__PURE__*/_jsx(SidebarPanel, {
    mobile: mobile,
    open: open,
    onToggle: onToggle,
    children: /*#__PURE__*/_jsxs(PanelContent, {
      children: [logo && logoCollapsed && /*#__PURE__*/_jsx(LogoContainer, {
        mobile: mobile,
        hasTenants: hasTenants,
        children: open ? /*#__PURE__*/_jsx("div", {
          children: logo
        }) : /*#__PURE__*/_jsx("div", {
          children: logoCollapsed
        })
      }), TenantSwitcher && /*#__PURE__*/_jsx(TenantSwitcher, {
        mobile: mobile
      }), /*#__PURE__*/_jsx(SidebarLinks, {
        links: links,
        open: open,
        pathname: pathname,
        onItemClick: onItemClick,
        enableIosTap: enableIosTap,
        hasTenants: hasTenants,
        mobile: mobile,
        customWrapper: customWrapper
      }), scrollFooter && children, FooterComponent && /*#__PURE__*/_jsx(FooterComponent, {}), !FooterComponent && copyright && /*#__PURE__*/_jsxs(Copyright, {
        $open: open,
        children: ["\xA9 ", year, " OpenVPN Inc. All Rights Reserved"]
      }), !scrollFooter && children]
    })
  });
}
export default Sidebar;